<template>
  <div class="total-info-block">
    <div class="total-info-block-title">
      {{ $t("component.TotalInfoBlock.found") }}
      <strong class="text-gray-900">{{ formattedTotal }}</strong>
      {{ $tc("component.TotalInfoBlock.resultsCountWord", total) }}
    </div>
  </div>
</template>

<script>
import moneyService from "@/services/money.service";

export default {
  name: "TotalInfoBlock",
  props: {
    total: {
      type: Number,
      required: true,
    },
  },
  computed: {
    formattedTotal() {
      return moneyService.separatedMoney(this.total, 0).integer;
    },
  },
};
</script>

<style lang="postcss" scoped>
.total-info-block {
  @apply pb-4 text-right text-sm text-gray-500;
}
</style>
